// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'
import { mediaMax } from 'styles/media'
import Title from 'components/atoms/Title'
import Text from 'components/atoms/Text'
import { Checkbox } from 'antd'
import Colors from 'styles/colors'

const DescWrapper = styled.div`
  margin-top: ${spacing.small_2}px;
`

const CheckboxListWrapper = styled.div`
  margin-top: ${spacing.medium_2}px;
`

const Field = styled.div`
  margin-top: ${spacing.large}px;
`
const Form = styled.form`
  position: relative;
`

const CheckboxWrapper = styled.div`
  &:not(:first-of-type) {
    margin-top: ${spacing.medium_2}px;
  }
`
const Desc = styled.p`
  margin-top: ${spacing.small}px;
  font-size: ${fontSize.small}px;
  color: ${Colors.mono.gray50};
  line-height: 1.363;
`

export default props => (
  <Form onSubmit={props.onSubmit}>
    <Title fontSize={fontSize.medium_2}>{i18n.t('メール・通知')}</Title>
    <Field>
      <Title tag="h2">{i18n.t('page.setting.mailNotificationSetting')}</Title>
      <DescWrapper>
        <Text desc>{i18n.t('page.setting.mailNotificationSettingDesc')}</Text>
      </DescWrapper>
      <CheckboxListWrapper>
        <CheckboxWrapper>
          <Checkbox
            disabled={true}
            onChange={props.onChange}
            name="canReceiveFeatureMail"
            checked={props.setting.canReceiveFeatureMail}
          >
            {i18n.t('スペースマーケットからのお知らせ')}
            <Desc>{i18n.t('page.setting.mailFromSpmktDesc')}</Desc>
          </Checkbox>
        </CheckboxWrapper>
        <CheckboxWrapper>
          <Checkbox
            onChange={props.onChange}
            name="canReceiveReminderMail"
            checked={props.setting.canReceiveReminderMail}
          >
            {i18n.t('イベント主催・参加に関するリマインド')}
            <Desc>
              {i18n.t(
                '主催、または参加登録したイベントについて、やるべきことがある場合にリマインドをお送りします。受信設定にしておくことをおすすめします。',
              )}
            </Desc>
          </Checkbox>
        </CheckboxWrapper>
        <CheckboxWrapper>
          <Checkbox
            onChange={props.onChange}
            name="canReceiveRecommendMail"
            checked={props.setting.canReceiveRecommendMail}
          >
            {i18n.t('お得キャンペーン＆ヒントに関するお知らせ')}
            <Desc>
              {i18n.t('お得なキャンペーン情報やヒントのご案内をお送りします。')}
            </Desc>
          </Checkbox>
        </CheckboxWrapper>
        {/* <CheckboxWrapper>
          <Checkbox
            onChange={props.onChange}
            name="canReceiveActionMail"
            checked={props.setting.canReceiveActionMail}>
            {i18n.t('')}
            <Desc>{i18n.t('page.setting.mailCampaignDesc')}</Desc>
          </Checkbox>
        </CheckboxWrapper> */}
      </CheckboxListWrapper>
    </Field>
  </Form>
)
